import React, { ComponentPropsWithRef, FC } from 'react';
import { PrimaryButton } from '@components/buttons/FlatButton/FlatButton.component';
import { IconSizes } from '@components/icons/icon.types';
import { WeatherCodeIcon } from '@components/icons/meteo/WeatherCode';
import { Text } from '@components/Text/Text.component';
import { WeatherCode } from '@meteo/types';
import { Breakpoint, useIsBreakpointDown } from '@styles/breakpoints';
import classnames from 'classnames';

import styles from './NoCityOverlay.module.scss';

const NoCityOverlay: FC<ComponentPropsWithRef<'div'> & { i18nTitle: string; i18nBody: string }> = ({
  i18nTitle,
  i18nBody,
  className,
  ...rest
}) => {
  const isMobile = useIsBreakpointDown(Breakpoint.m);

  const setFocusToMeteoCityAutocomplete = () => {
    const autocompleteInput = document.querySelector(
      '#meteo-city-autocomplete-input-no-city, #meteo-city-autocomplete-input'
    );
    if (autocompleteInput) {
      window.scrollTo(0, 0);
      (autocompleteInput as HTMLInputElement).focus();
    }
  };

  const rootClass = classnames(styles.noCityOverlay, 'overlay-message', className);
  return (
    <div className={rootClass} {...rest}>
      <WeatherCodeIcon className={styles.noCityIllu} variant={IconSizes.xl} weatherCode={WeatherCode.MainlyCloudy} />
      <Text alignment="center" className={styles.noCityTitle} i18nKey={i18nTitle} tag="div" variant="h3" />
      <Text
        alignment="center"
        className={styles.noCitySubtitle}
        i18nKey={i18nBody}
        tag="div"
        variant={isMobile ? 'small' : 'p'}
      />
      <PrimaryButton
        className={styles.noCityButton}
        isDarkGreen
        onClick={setFocusToMeteoCityAutocomplete}
        textProps={{ i18nKey: 'meteo.no-city-overlay.button' }}
      />
    </div>
  );
};

export { NoCityOverlay };
